export default __webpack_public_path__ + "static/media/outside.071457e7.png";